import { render, staticRenderFns } from "./DiamOptimization.vue?vue&type=template&id=a0e86b3e&scoped=true"
import script from "./DiamOptimization.vue?vue&type=script&lang=js"
export * from "./DiamOptimization.vue?vue&type=script&lang=js"
import style0 from "./DiamOptimization.vue?vue&type=style&index=0&id=a0e86b3e&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0e86b3e",
  null
  
)

export default component.exports